import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({ providedIn: 'root' })
export class MessageService {
    private subject = new Subject<any>();

    constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

    /**
    * Description: method that relates the event when it is recurring
    * Autor: Luis Hernandez
    * @param 
    * @return
    */
    sendMessage(message: string, productExist:any) {
        this.subject.next({ text: message, text2:productExist });
    }

    /**
    * Description: method that relates the event when it is unique
    * Autor: Luis Hernandez
    * @param 
    * @return
    */
    viewOnlyEvent(message: string) {
        this.subject.next({ text: message });
    }

    clearMessages() {
        this.subject.next();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }


    /**
    * Description: Method that calls the web service that returns the recurring payment form
    * Autor: Luis Hernandez
    * @param 
    * @return
    */
    replaceRecurrent(data) {
        return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_POST_CHANGEPRODUCTFAVOR, data);
    }

}